import { BreezeBadge } from 'trellis-ecosystem';
import { H3 } from 'foundations-components/transitional/components/H3';
import { List } from 'foundations-components/transitional/components/List';
import { ListItem } from 'foundations-components/transitional/components/List';
import { Small } from 'foundations-components/transitional/components/Small';
import { View } from 'foundations-components/components/View';
import FormattedDateTime from 'I18n/components/FormattedDateTime';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Alert } from 'foundations-components/transitional/components/Alert';
import { PanelBody } from 'foundations-components/transitional/components/PanelBody';
import { Section } from 'foundations-components/transitional/components/Section';
import { Tabs, Tab } from 'foundations-components/transitional/components/Tabs';
import { Flex } from 'foundations-components/components/Flex';
import { HeroImage } from '../DetailsPanel/HeroImage';
import { useAuthState } from '../../../app/hooks/useAuthState';
import { getBodyHtml, getHeroImageUrl } from '../../../app/utils/getHeroImageUrl';
import { SanitizedHtml } from '../SanitizedHtml';
import RolloutProductDetailsPanelTabDetails from './RolloutProductUpdateDetailsPanelTabDetails';
import { utcToRolloutOffsetLocal } from '../../../app/utils/dateUtils';
import { GATES } from '../../../app/utils/constants';
import RolloutProductDetailsPanelFooter from './RolloutProductUpdateDetailsPanelFooter';
import RolloutProductUpdateDetailsPanelBetaInfo from './RolloutProductUpdateDetailsPanelBetaInfo';
import RolloutProductUpdateDate from '../RolloutProductUpdateDate';
import { isEnrolled } from '../utils/enrollmentStatus';
import RolloutProductUpdateStatusTagShort from '../RolloutProductUpdateStatusTagShort';
import GateWrapper from '../utils/GateWrapper';
import { FavoriteRolloutButton } from './FavoriteRolloutButton';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const RolloutProductDetailsPanelContent = ({
  rolloutProductUpdate
}) => {
  const {
    releaseDate,
    rollout: {
      id: rolloutId,
      enrollmentStatus,
      hasAiFeature
    },
    id: productUpdateId,
    title,
    rolloutState,
    translatedContent,
    stageDate,
    heroImage,
    ctaUrl,
    isFavorite
  } = rolloutProductUpdate;
  const {
    content
  } = translatedContent;
  const {
    user
  } = useAuthState();
  const locale = user ? user.locale : 'unknown';
  const enrolled = isEnrolled(enrollmentStatus);
  const showRoadmapDisclaimer = rolloutState === 'IN_DEVELOPMENT';
  const isBeta = rolloutState === 'PRIVATE_BETA' || rolloutState === 'PUBLIC_BETA';
  const releaseDateLocalToUser = releaseDate ? utcToRolloutOffsetLocal(releaseDate).valueOf() : null;
  const shouldShowReleaseDate = releaseDateLocalToUser && releaseDateLocalToUser > new Date().valueOf() && rolloutState !== 'LIVE' && rolloutState !== 'SUNSET';
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(PanelBody, {
      "data-test-id": "details-panel-content",
      paddingInline: "500",
      paddingBlockStart: "400",
      children: [/*#__PURE__*/_jsxs(Section, {
        paddingInline: "500",
        children: [/*#__PURE__*/_jsxs(Flex, {
          justifyContent: "space-between",
          alignItems: "start",
          children: [/*#__PURE__*/_jsx(GateWrapper, {
            ungatedToAny: [GATES.NEW_TO_YOU_GATE],
            fallbackComponent: /*#__PURE__*/_jsx(H3, {
              marginBlockEnd: "25",
              children: title
            }),
            children: /*#__PURE__*/_jsxs(Flex, {
              alignItems: "start",
              gap: "200",
              children: [/*#__PURE__*/_jsx(H3, {
                marginBlockEnd: "25",
                children: title
              }), hasAiFeature && /*#__PURE__*/_jsx(View, {
                paddingBlockStart: "100",
                children: /*#__PURE__*/_jsx(BreezeBadge, {})
              })]
            })
          }), /*#__PURE__*/_jsx(FavoriteRolloutButton, {
            productUpdateId: productUpdateId,
            productUpdateTitle: title,
            rolloutId: rolloutId,
            initialIsFavorite: isFavorite
          })]
        }), /*#__PURE__*/_jsx(View, {
          marginBlock: "400",
          as: "div",
          children: /*#__PURE__*/_jsx(Small, {
            use: "help",
            children: /*#__PURE__*/_jsxs(List, {
              use: "inline-divided",
              children: [/*#__PURE__*/_jsx(ListItem, {
                children: /*#__PURE__*/_jsx(RolloutProductUpdateStatusTagShort, {
                  rolloutState: rolloutState
                })
              }), /*#__PURE__*/_jsxs(ListItem, {
                children: [/*#__PURE__*/_jsx(FormattedMessage, {
                  message: "app.detailsPanel.lastUpdated"
                }), ": ", /*#__PURE__*/_jsx(RolloutProductUpdateDate, {
                  date: stageDate
                })]
              }), shouldShowReleaseDate && /*#__PURE__*/_jsx(ListItem, {
                children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
                  message: "app.statusTags.scheduledForReleasePrefix_jsx",
                  elements: {
                    FormattedDateTime
                  },
                  options: {
                    type: 'userTz',
                    value: releaseDateLocalToUser,
                    format: 'LL'
                  }
                })
              })]
            })
          })
        }), isBeta && enrolled && /*#__PURE__*/_jsx(RolloutProductUpdateDetailsPanelBetaInfo, {
          rolloutProductUpdate: rolloutProductUpdate
        })]
      }), /*#__PURE__*/_jsx(View, {
        paddingInline: "500",
        children: /*#__PURE__*/_jsxs(Tabs, {
          "data-test-id": "details-panel-about-tab",
          defaultSelected: "1",
          fill: true,
          children: [/*#__PURE__*/_jsxs(Tab, {
            tabId: "1",
            title: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "app.detailsPanel.about"
            }),
            children: [showRoadmapDisclaimer && /*#__PURE__*/_jsx(Alert, {
              titleText: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "app.alertTitle.note"
              }),
              marginBlockEnd: "500",
              children: /*#__PURE__*/_jsx(Small, {
                children: /*#__PURE__*/_jsx(FormattedMessage, {
                  message: "app.detailsPanel.disclaimer"
                })
              })
            }), /*#__PURE__*/_jsx(HeroImage, {
              type: heroImage,
              heroImageUrl: getHeroImageUrl(content, productUpdateId, locale),
              callToActionUrl: ctaUrl,
              productUpdateId: productUpdateId
            }), /*#__PURE__*/_jsx(View, {
              "data-test-id": "details-panel-about-tab-content",
              children: /*#__PURE__*/_jsx(SanitizedHtml, {
                body: getBodyHtml(content, productUpdateId, locale),
                WrapperComponent: 'div'
              })
            })]
          }), /*#__PURE__*/_jsx(Tab, {
            "data-test-id": "details-panel-details-tab",
            tabId: "2",
            title: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "app.detailsPanel.details"
            }),
            children: /*#__PURE__*/_jsx(RolloutProductDetailsPanelTabDetails, {
              rolloutProductUpdate: rolloutProductUpdate
            })
          })]
        })
      })]
    }), /*#__PURE__*/_jsx(RolloutProductDetailsPanelFooter, {
      enrolled: enrolled,
      isBeta: isBeta,
      rolloutProductUpdate: rolloutProductUpdate
    })]
  });
};
export default RolloutProductDetailsPanelContent;